import React from 'react';

// ENUMS
import { Icons } from '../../enums/icons';

// ICONS
import Icon from '../Icon/Icon';

// INTERFACE
import { IMenuItemProps } from '../../interfaces/IMenuItem.interface';

// STYLES
import { MobileMenuItens, MobileMenuItemHeader, ItemSubMenuContainer } from './style';

interface ISubMenuMobile {
  closeMenu: () => void;
  backMenu: () => void;
  itemMenu: IMenuItemProps;
}

const SubMenuMobile: React.FC<ISubMenuMobile> = ({ backMenu, closeMenu, itemMenu }: ISubMenuMobile) => {
  const ItemSelected = itemMenu.itemMenu;

  const renderSubMenuItens = () => {
    return itemMenu.subItems?.map((item: IMenuItemProps, index: number) => {
      const ItemMenu = item.itemMenu;
      return (
        <ItemSubMenuContainer key={index} onClick={closeMenu}>
          <ItemMenu />
        </ItemSubMenuContainer>
      );
    });
  };

  return (
    <>
      <MobileMenuItens>
        <MobileMenuItemHeader>
          <ItemSelected />
        </MobileMenuItemHeader>
        {renderSubMenuItens()}
        <MobileMenuItemHeader onClick={backMenu}>
          <a>
            <Icon type={Icons.ARROW_LEFT} />
            <label>Voltar</label>
          </a>
        </MobileMenuItemHeader>
      </MobileMenuItens>
    </>
  );
};

export default SubMenuMobile;
